const initial = {
  building_id: null,
  floor_id: null,
  status: 'hidden',
  callback: null
};

export default {
  namespaced: true,
  state: {...initial},
  actions: {
    clear({commit}) {
      commit('CLOSE_FORM');
    },
    create({commit}, {
      building_id,
      callback
    }) {
      commit('SHOW_FORM', {
        status: 'create',
        building_id: building_id,
        floor_id: null,
        callback
      });
    },
    edit({commit}, {
      floor_id,
      callback
    }) {
      commit('SHOW_FORM', {
        status: 'edit',
        building_id: null,
        floor_id: floor_id,
        callback
      });
    }
  },
  mutations: {
    CLOSE_FORM(state) {
      state.status = initial.status;
      state.floor_id = initial.floor_id;
      state.building_id = initial.building_id;
      state.callback = initial.callback;
    },
    SHOW_FORM(state, {
      status,
      floor_id,
      building_id,
      callback
    }) {
      state.status = status;
      state.floor_id = floor_id;
      state.building_id = building_id;
      state.callback = callback || initial.callback;
    }
  }
};
